export default __webpack_public_path__ + "51568344db548cd87aebfc512d689f64.png";